import React from 'react';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Flex, Button } from 'roo-ui/components';
import includes from 'lodash/includes';
import { FOOTER, ANIMATION_DURATION } from './constants';

const PhoneOnlyFooter = styled(Flex)`
  padding: ${themeGet('space.2')};
  box-shadow: ${themeGet('shadows.footer')};
  background: ${themeGet('colors.white')};
  height: ${FOOTER}px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  opacity: 0;
  transition: opacity ${ANIMATION_DURATION}ms ease-in;

  ${({ transitionState }) =>
    includes(['entering', 'entered'], transitionState) &&
    css`
      opacity: 1;
    `};

  ${({ transitionState }) =>
    transitionState === 'exited' &&
    css`
      display: none;
    `};
`;

PhoneOnlyFooter.displayName = 'PhoneOnlyFooter';

const Footer = ({ transitionState, submitModal, buttonText }) => (
  <PhoneOnlyFooter transitionState={transitionState}>
    <Button variant="primary" block onClick={submitModal} data-testid="apply-button">
      {buttonText}
    </Button>
  </PhoneOnlyFooter>
);

Footer.propTypes = {
  transitionState: PropTypes.string.isRequired,
  submitModal: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};

Footer.defaultProps = {
  buttonText: 'Apply',
};

export default Footer;
